export const FOUNDATION = "FOUNDATION"

export const EXCLUDED_MODULES =
  // eslint-disable-next-line no-undef
  typeof __ENVIRONMENT_TYPE__ !== "undefined" && __ENVIRONMENT_TYPE__ === "prod"
    ? ["lrh", "cf"]
    : []
